import { Suspense } from 'react';
import LandingPage from './components/LandingPage';
import Pillar from './components/FivePillars';
import PatentContextProvider from './context/PatentContextProvider';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";


function App() {
  return (
    <div>
      <PatentContextProvider>
        <Router>
          <Routes>
            <Route path='/' element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}> <LandingPage /></Suspense>} />
            <Route path='seven-pillars' element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}> <Pillar /></Suspense>} />
          </Routes>
        </Router>
      </PatentContextProvider>
    </div>
  );
}

export default App;
